import { render, staticRenderFns } from "./headCard.vue?vue&type=template&id=38c384c2&scoped=true&"
import script from "./headCard.vue?vue&type=script&lang=js&"
export * from "./headCard.vue?vue&type=script&lang=js&"
import style0 from "./headCard.vue?vue&type=style&index=0&id=38c384c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c384c2",
  null
  
)

export default component.exports